(function () {
  'use strict';

  if (window.__catalogueLogoBannerAssetLoaded) return;
  window.__catalogueLogoBannerAssetLoaded = true;

  function toBoolean(value) {
    return value === true || value === 'true' || value === '1';
  }

  function toNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function initSimpleLogoBanner(bannerSection) {
    if (!bannerSection || !bannerSection.isConnected) return;

    const section = bannerSection.closest('.simple-logo-banner-slider-wrapper');
    if (!section) return;

    const validSlides = toNumber(bannerSection.dataset.validSlides, 0);
    const enableAutoplay = toBoolean(bannerSection.dataset.enableAutoplay);
    const autoplayDelay = toNumber(bannerSection.dataset.autoplayDelay, 5000);
    const pauseAutoplayOnHover = toBoolean(bannerSection.dataset.pauseAutoplayOnHover);
    const enableMobileLogoSlider = toBoolean(bannerSection.dataset.enableMobileLogoSlider);
    const showLogoArrows = toBoolean(bannerSection.dataset.showLogoArrows);
    const bannerSpeed = toNumber(bannerSection.dataset.bannerSpeed, 900);
    const showDesktopBannerArrows = toBoolean(bannerSection.dataset.showDesktopBannerArrows);
    const showMobileBannerArrows = toBoolean(bannerSection.dataset.showMobileBannerArrows);
    const enableMobileBannerSwipe = toBoolean(bannerSection.dataset.enableMobileBannerSwipe);
    const mobileSwipeThreshold = toNumber(bannerSection.dataset.mobileSwipeThreshold, 10);
    const mobileSwipeSensitivity = toNumber(bannerSection.dataset.mobileSwipeSensitivity, 90) / 100;
    const logoSliderSpeed = toNumber(bannerSection.dataset.logoSliderSpeed, 450);
    const mobileLogoSlides = toNumber(bannerSection.dataset.mobileLogoSlides, 3);

    if (section.simpleLogoBannerRetryTimer) {
      window.clearTimeout(section.simpleLogoBannerRetryTimer);
      section.simpleLogoBannerRetryTimer = null;
    }

    if (typeof section.simpleLogoBannerCleanup === 'function') {
      section.simpleLogoBannerCleanup();
    }

    const bannerElement = section.querySelector('[data-simple-logo-banner]');
    const logoSliderElement = section.querySelector('[data-simple-logo-swiper]');
    const logoTabs = Array.from(section.querySelectorAll('[data-simple-logo-tab]'));
    const logoPrevButton = section.querySelector('[data-logo-arrow-prev]');
    const logoNextButton = section.querySelector('[data-logo-arrow-next]');
    const bannerPrevButton = section.querySelector('[data-banner-arrow-prev]');
    const bannerNextButton = section.querySelector('[data-banner-arrow-next]');
    
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const desktopMenuMedia = window.matchMedia('(min-width: 750px)');
    const finePointerMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    
    const menuTriggers = Array.from(section.querySelectorAll('[data-logo-menu-trigger]'));
    const menuPanels = Array.from(section.querySelectorAll('[data-logo-menu-panel]'));
    const eventController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const eventSignal = eventController ? { signal: eventController.signal } : undefined;

    const isRtl = bannerSection.getAttribute('data-slider-direction') === 'rtl';

    if (!bannerElement) return;

    if (typeof window.Swiper === 'undefined') {
      section.simpleLogoBannerRetryTimer = window.setTimeout(function () {
        initSimpleLogoBanner(bannerSection);
      }, 120);
      return;
    }

    if (bannerElement.swiper) bannerElement.swiper.destroy(true, true);
    if (logoSliderElement && logoSliderElement.swiper) logoSliderElement.swiper.destroy(true, true);

    let logoSwiper = null;

    function getActiveIndex(swiper) {
      return typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
    }

    function updateLogoTabs(bannerSwiper) {
      const activeIndex = getActiveIndex(bannerSwiper);
      const safeIndex = Math.max(0, Math.min(logoTabs.length - 1, Number(activeIndex) || 0));

      logoTabs.forEach(function (tab) {
        const tabIndex = Number(tab.getAttribute('data-simple-logo-tab'));
        const isActive = tabIndex === safeIndex;

        tab.classList.toggle('is-active', isActive);
        if (isActive) {
          tab.setAttribute('aria-current', 'true');
        } else {
          tab.removeAttribute('aria-current');
        }
      });

      if (logoSwiper && !logoSwiper.destroyed && mobileMedia.matches) {
        logoSwiper.slideTo(safeIndex, logoSliderSpeed);
      }
    }

    const bannerNavigationConfig = (showDesktopBannerArrows || showMobileBannerArrows) && bannerPrevButton && bannerNextButton
      ? { prevEl: bannerPrevButton, nextEl: bannerNextButton }
      : undefined;

    function canSwipeBannerOnMobile() {
      return mobileMedia.matches && enableMobileBannerSwipe;
    }

    const bannerSwiper = new Swiper(bannerElement, {
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      loop: validSlides > 1,
      loopAdditionalSlides: 1,
      loopPreventsSliding: true,
      preventInteractionOnTransition: true,
      roundLengths: true,
      normalizeSlideIndex: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      speed: bannerSpeed,
      allowTouchMove: canSwipeBannerOnMobile(),
      followFinger: canSwipeBannerOnMobile(),
      shortSwipes: true,
      longSwipes: true,
      longSwipesMs: 300,
      longSwipesRatio: 0.34,
      resistance: true,
      resistanceRatio: 0.72,
      touchRatio: mobileSwipeSensitivity,
      touchAngle: 45,
      threshold: mobileSwipeThreshold,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: bannerNavigationConfig,
      autoplay: enableAutoplay
        ? { delay: autoplayDelay, disableOnInteraction: false, waitForTransition: true }
        : false,
      on: {
        init: function (swiper) {
          updateLogoTabs(swiper);
        },
        slideChange: function (swiper) {
          updateLogoTabs(swiper);
        },
        slideChangeTransitionEnd: function (swiper) {
          updateLogoTabs(swiper);
        },
        transitionEnd: function (swiper) {
          swiper.updateSlidesClasses();
        },
        touchStart: function (swiper) {
          if (enableAutoplay && swiper.autoplay) {
            swiper.autoplay.stop();
          }
        },
        touchEnd: function (swiper) {
          if (enableAutoplay && swiper.autoplay) {
            swiper.autoplay.start();
          }
        },
        navigationNext: function (swiper) {
          if (enableAutoplay && swiper.autoplay) {
            swiper.autoplay.stop();
            swiper.autoplay.start();
          }
        },
        navigationPrev: function (swiper) {
          if (enableAutoplay && swiper.autoplay) {
            swiper.autoplay.stop();
            swiper.autoplay.start();
          }
        }
      }
    });

/* =========================================
       Strict spam-click protection for banner arrows
       ========================================= */
    if (bannerPrevButton && bannerNextButton) {
      [bannerPrevButton, bannerNextButton].forEach(function (button) {
        // The 'true' argument captures the click before Swiper's native listener sees it
        button.addEventListener('click', function (event) {
          if (bannerSwiper.animating) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true); 
      });
    }

    let activeMenuId = null;
    let activeMenuTrigger = null;
    let closeMenuTimer = null;
    let openMenuFrame = null;
    let openMenuSequence = 0;
    let closeMenuSequence = 0;
    const panelCloseTimers = new Map();
    let keyboardNavigation = false;

    if (pauseAutoplayOnHover && finePointerMedia.matches) {
      bannerElement.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch' && enableAutoplay && bannerSwiper.autoplay) {
          if (bannerSwiper.animating) return; 
          bannerSwiper.autoplay.stop();
        }
      }, eventSignal);
      
      bannerElement.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'touch' && enableAutoplay && bannerSwiper.autoplay && !activeMenuId) {
          bannerSwiper.autoplay.start();
        }
      }, eventSignal);
    }

    function getMenuPanel(menuId) {
      return menuPanels.find(panel => panel.getAttribute('data-logo-menu-panel') === menuId) || null;
    }

    function preparePanelForOpening(panel) {
      const timer = panelCloseTimers.get(panel);
      if (timer) window.clearTimeout(timer);
      panel.classList.remove('is-open', 'is-closing');
      panel.classList.add('is-preparing');
      panel.setAttribute('aria-hidden', 'true');
      panel.toggleAttribute('inert', true);
    }

    function finishPanelOpening(panel) {
      const timer = panelCloseTimers.get(panel);
      if (timer) window.clearTimeout(timer);
      panel.classList.remove('is-preparing', 'is-closing');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      panel.toggleAttribute('inert', false);
    }

    function closePanel(panel, skipAnimation) {
      const timer = panelCloseTimers.get(panel);
      if (timer) window.clearTimeout(timer);
      
      const wasVisible = panel.classList.contains('is-open') || panel.classList.contains('is-closing');
      panel.classList.remove('is-preparing', 'is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.toggleAttribute('inert', true);

      if (skipAnimation || !wasVisible) {
        panel.classList.remove('is-closing');
        return;
      }

      panel.classList.add('is-closing');
      panelCloseTimers.set(panel, window.setTimeout(() => {
        panel.classList.remove('is-closing');
        panelCloseTimers.delete(panel);
      }, 500));
    }

    function syncCatalogueMenuOverflow(panel) {
      if (!panel) return;
      const menuInner = panel.querySelector('.simple-logo-banner__catalogue-menu-inner');
      if (!menuInner) return;
      
      menuInner.classList.remove('has-overflow');
      const menuHeader = menuInner.querySelector('.simple-logo-banner__catalogue-menu-header');
      const menuList = menuInner.querySelector('.simple-logo-banner__catalogue-menu-list');
      
      const naturalContentHeight = Math.ceil((menuHeader ? menuHeader.offsetHeight : 0) + (menuList ? menuList.offsetHeight : 0));
      const hasOverflow = naturalContentHeight > menuInner.clientHeight + 2;
      
      menuInner.classList.toggle('has-overflow', hasOverflow);
      if (!hasOverflow) menuInner.scrollTop = 0;
    }

    function positionCatalogueMenu(panel, trigger) {
      if (!panel || !trigger) return;

      const sectionRect = section.getBoundingClientRect();
      const triggerRect = trigger.getBoundingClientRect();
      const glassInlineInset = 8; 

      const triggerWidth = Math.max(1, triggerRect.width);
      const menuWidth = Math.max(1, Math.min(triggerWidth - (glassInlineInset * 2), sectionRect.width));
      const triggerLeft = triggerRect.left - sectionRect.left;
      const triggerTop = triggerRect.top - sectionRect.top;

      const preferredMenuX = triggerLeft + glassInlineInset;
      const menuX = Math.min(Math.max(preferredMenuX, 0), Math.max(0, sectionRect.width - menuWidth));
      const availableHeight = Math.max(120, triggerTop - 8);

      panel.style.setProperty('--menu-width', menuWidth.toFixed(2) + 'px');
      panel.style.setProperty('--menu-available-height', Math.round(availableHeight) + 'px');

      syncCatalogueMenuOverflow(panel);

      const panelHeight = panel.offsetHeight;
      const menuY = Math.max(0, triggerTop - panelHeight + 3);

      panel.style.setProperty('--menu-x', menuX.toFixed(2) + 'px');
      panel.style.setProperty('--menu-y', Math.round(menuY) + 'px');
    }

    function openCatalogueMenu(menuId, trigger) {
      if (!desktopMenuMedia.matches) return;
      const targetPanel = getMenuPanel(menuId);
      if (!targetPanel) return;

      closeMenuSequence += 1;
      window.clearTimeout(closeMenuTimer);
      
      openMenuSequence += 1;
      if (openMenuFrame) window.cancelAnimationFrame(openMenuFrame);

      if (activeMenuId === menuId && targetPanel.classList.contains('is-open')) {
        positionCatalogueMenu(targetPanel, trigger);
        return;
      }

      if (activeMenuId !== menuId) {
        if (!activeMenuId && enableAutoplay && bannerSwiper.autoplay) bannerSwiper.autoplay.stop();
        activeMenuId = menuId;
        activeMenuTrigger = trigger;
      }

      menuPanels.forEach(panel => { if (panel !== targetPanel) closePanel(panel, false); });

      preparePanelForOpening(targetPanel);
      positionCatalogueMenu(targetPanel, trigger);

      void targetPanel.offsetHeight;
      const currentOpenSequence = openMenuSequence;

      openMenuFrame = window.requestAnimationFrame(() => {
        openMenuFrame = window.requestAnimationFrame(() => {
          if (currentOpenSequence !== openMenuSequence || activeMenuId !== menuId) return;
          finishPanelOpening(targetPanel);
        });
      });

      menuTriggers.forEach(menuTrigger => {
        const isOpen = menuTrigger.getAttribute('data-logo-menu-trigger') === menuId;
        menuTrigger.classList.toggle('menu-is-open', isOpen);
        menuTrigger.setAttribute('aria-expanded', String(isOpen));
      });

      section.classList.add('catalogue-menu-is-open');
    }

    function closeCatalogueMenu(immediate) {
      closeMenuSequence += 1;
      window.clearTimeout(closeMenuTimer);
      const requestedCloseSequence = closeMenuSequence;

      const close = function () {
        if (requestedCloseSequence !== closeMenuSequence) return;
        
        openMenuSequence += 1;
        if (openMenuFrame) window.cancelAnimationFrame(openMenuFrame);

        menuPanels.forEach(panel => closePanel(panel, false));
        menuTriggers.forEach(trigger => {
          trigger.classList.remove('menu-is-open');
          trigger.setAttribute('aria-expanded', 'false');
        });

        activeMenuId = null;
        activeMenuTrigger = null;
        section.classList.remove('catalogue-menu-is-open');
        if (enableAutoplay && bannerSwiper.autoplay) bannerSwiper.autoplay.start();
      };

      if (immediate) close();
      else closeMenuTimer = window.setTimeout(close, 210);
    }

    menuTriggers.forEach(trigger => {
      const menuId = trigger.getAttribute('data-logo-menu-trigger');
      const panel = getMenuPanel(menuId);
      if (!panel) return;

      trigger.addEventListener('pointerenter', event => {
        if (finePointerMedia.matches && event.pointerType !== 'touch') openCatalogueMenu(menuId, trigger);
      }, eventSignal);
      trigger.addEventListener('pointerleave', event => {
        if (finePointerMedia.matches && event.pointerType !== 'touch') closeCatalogueMenu(false);
      }, eventSignal);
      trigger.addEventListener('focusin', () => {
        if (keyboardNavigation || finePointerMedia.matches) openCatalogueMenu(menuId, trigger);
      }, eventSignal);

      panel.addEventListener('pointerenter', () => {
        closeMenuSequence += 1;
        window.clearTimeout(closeMenuTimer);
      }, eventSignal);
      panel.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'touch') closeCatalogueMenu(false);
      }, eventSignal);
    });

    logoTabs.forEach(tab => {
      if (tab.tagName === 'A' && tab.getAttribute('href')) {
        tab.addEventListener('click', () => closeCatalogueMenu(true), eventSignal);
        return;
      }

      const menuId = tab.getAttribute('data-logo-menu-trigger');
      if (!menuId) return;

      tab.addEventListener('click', event => {
        if (!desktopMenuMedia.matches) return;
        event.preventDefault();
        activeMenuId === menuId ? closeCatalogueMenu(true) : openCatalogueMenu(menuId, tab);
      }, eventSignal);

      tab.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openCatalogueMenu(menuId, tab);
        }
      }, eventSignal);
    });

    section.addEventListener('focusout', event => {
      if (!activeMenuId) return;
      window.requestAnimationFrame(() => {
        const nextFocused = event.relatedTarget || document.activeElement;
        const activePanel = getMenuPanel(activeMenuId);
        if (nextFocused && (menuTriggers.some(t => t === nextFocused || t.contains(nextFocused)) || (activePanel && activePanel.contains(nextFocused)))) return;
        closeCatalogueMenu(true);
      });
    }, eventSignal);

    section.addEventListener('keydown', event => {
      if (event.key === 'Escape' && activeMenuId) {
        event.preventDefault();
        const triggerToFocus = activeMenuTrigger;
        closeCatalogueMenu(true);
        if (triggerToFocus) triggerToFocus.focus();
      }
    }, eventSignal);

    document.addEventListener('keydown', event => { if (event.key === 'Tab') keyboardNavigation = true; }, eventSignal);
    document.addEventListener('pointerdown', event => {
      keyboardNavigation = false;
      if (!activeMenuId) return;
      const activePanel = getMenuPanel(activeMenuId);
      if ((activeMenuTrigger && activeMenuTrigger.contains(event.target)) || (activePanel && activePanel.contains(event.target))) return;
      closeCatalogueMenu(true);
    }, eventSignal);

    let menuResizeFrame = null;
    window.addEventListener('resize', () => {
      if (!activeMenuId || !activeMenuTrigger || menuResizeFrame) return;
      menuResizeFrame = window.requestAnimationFrame(() => {
        menuResizeFrame = null;
        positionCatalogueMenu(getMenuPanel(activeMenuId), activeMenuTrigger);
      });
    }, eventSignal);

    function createMobileLogoSwiper() {
      if (!enableMobileLogoSlider || !mobileMedia.matches || !logoSliderElement) {
        if (logoSwiper) logoSwiper.destroy(true, true);
        logoSwiper = null;
        return;
      }
      if (logoSwiper && !logoSwiper.destroyed) return;

      logoSwiper = new Swiper(logoSliderElement, {
        direction: 'horizontal',
        slidesPerView: mobileLogoSlides,
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        loop: false,
        speed: logoSliderSpeed,
        
        /* =========================================
           ADDED: Premium "Sticky" Free Mode
           ========================================= */
        freeMode: {
          enabled: true,
          sticky: true,
          momentumRatio: 0.8,
          momentumVelocityRatio: 0.8
        },
        slideToClickedSlide: true, // Centers the logo beautifully when tapped
        /* ========================================= */
        
        roundLengths: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        grabCursor: true,
        simulateTouch: true,
        followFinger: true,
        threshold: 4,
        resistanceRatio: 0.72,
        slidesOffsetBefore: showLogoArrows ? 44 : 0,
        slidesOffsetAfter: showLogoArrows ? 44 : 0,
        navigation: (showLogoArrows && logoPrevButton && logoNextButton) ? {
          prevEl: isRtl ? logoNextButton : logoPrevButton,
          nextEl: isRtl ? logoPrevButton : logoNextButton
        } : undefined
      });

      updateLogoTabs(bannerSwiper);
    }

    createMobileLogoSwiper();
    
    mobileMedia.addEventListener('change', () => {
      bannerSwiper.params.allowTouchMove = canSwipeBannerOnMobile();
      bannerSwiper.params.followFinger = canSwipeBannerOnMobile();
      createMobileLogoSwiper();
    });

    section.simpleLogoBannerCleanup = function () {
      if (bannerSection.simpleLogoBannerInitFrame) window.cancelAnimationFrame(bannerSection.simpleLogoBannerInitFrame);
      if (section.simpleLogoBannerRetryTimer) window.clearTimeout(section.simpleLogoBannerRetryTimer);
      if (menuResizeFrame) window.cancelAnimationFrame(menuResizeFrame);
      closeCatalogueMenu(true);
      if (eventController) eventController.abort();
      if (logoSwiper) logoSwiper.destroy(true, true);
      if (bannerElement.swiper) bannerElement.swiper.destroy(true, true);
    };
  }

  function scheduleSimpleLogoBannerInit(bannerSection) {
    if (!bannerSection) return;
    if (bannerSection.simpleLogoBannerInitFrame) window.cancelAnimationFrame(bannerSection.simpleLogoBannerInitFrame);
    bannerSection.simpleLogoBannerInitFrame = window.requestAnimationFrame(() => {
      bannerSection.simpleLogoBannerInitFrame = window.requestAnimationFrame(() => {
        bannerSection.simpleLogoBannerInitFrame = null;
        initSimpleLogoBanner(bannerSection);
      });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.simple-logo-banner-section[data-section-id]').forEach(scheduleSimpleLogoBannerInit);
  }

  window.CatalogueLogoBanner = { scan: scan, init: scheduleSimpleLogoBannerInit };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', event => {
    const wrapper = document.getElementById('shopify-section-' + event.detail.sectionId);
    scheduleSimpleLogoBannerInit(wrapper ? wrapper.querySelector('.simple-logo-banner-section[data-section-id]') : null);
  });

  document.addEventListener('shopify:section:unload', event => {
    const wrapper = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (wrapper && typeof wrapper.simpleLogoBannerCleanup === 'function') wrapper.simpleLogoBannerCleanup();
  });
})();